import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { slugify } from "../../custom_utils/helpers";
import { pushBuildingBlockAction } from "./datalayer";
import { Link } from "./library/link";
import { QuickLinks } from "./quick_links";
export class CollectionBlock extends React.Component {
    componentDidMount() {
        setTimeout(()=>this.scrollToGroupByCurrentHash(), 500);
        window.addEventListener("hashchange", ()=>this.scrollToGroupByCurrentHash());
    }
    scrollToGroupByCurrentHash() {
        this.scrollToGroup(window.location.hash.substr(1));
    }
    scrollToGroup(slug) {
        const group = this.props.collectionGroups.find((g)=>g.slug === slug);
        if (!group) return;
        const element = document.querySelector(`[data-anchor="${slug}"]`);
        if (!element) return;
        element.scrollIntoView({
            behavior: "smooth"
        });
    }
    render() {
        const { title, introduction, displayQuickLinks, collectionGroups } = this.props;
        return /*#__PURE__*/ _jsxs("section", {
            className: "block block--knowledge-bank",
            children: [
                (title || introduction) && /*#__PURE__*/ _jsxs("header", {
                    className: "block__header",
                    children: [
                        title && /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l",
                            children: title
                        }),
                        introduction && /*#__PURE__*/ _jsx("div", {
                            className: "block__intro",
                            dangerouslySetInnerHTML: {
                                __html: introduction
                            }
                        })
                    ]
                }),
                displayQuickLinks && /*#__PURE__*/ _jsx(QuickLinks, {
                    title: "Direct naar...",
                    links: List(collectionGroups.map((group)=>({
                            title: group.title,
                            url: '#' + group.slug
                        }))),
                    handleScroll: (slug)=>this.scrollToGroup(slug),
                    pushAnalyticsEvent: (action)=>pushBuildingBlockAction(action)
                }),
                collectionGroups.map((group)=>/*#__PURE__*/ _jsxs("article", {
                        "data-anchor": group.slug,
                        className: "block__content",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "block__subtitle title--m",
                                children: group.title
                            }),
                            /*#__PURE__*/ _jsx("ul", {
                                className: "cards",
                                children: group.collectionItems.map((item, itemKey)=>/*#__PURE__*/ _jsx("li", {
                                        className: "card",
                                        children: /*#__PURE__*/ _jsxs(Link, {
                                            url: item.link,
                                            className: "card__link",
                                            "aria-labelledby": `a11y-card-title-${slugify(item.title)}`,
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "card__content",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h4", {
                                                            className: "card__title title--ms",
                                                            id: `a11y-card-title-${slugify(item.title)}`,
                                                            children: item.title
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "card__subtitle",
                                                            children: item.subtitle
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "card__text",
                                                            children: item.text
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "card__visual",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ _jsx("svg", {
                                                        className: "card__icon",
                                                        children: /*#__PURE__*/ _jsx("use", {
                                                            xlinkHref: `#icon--${item.icon == "none" ? "book" : item.icon}`
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }, `group-${group.slug}-${itemKey}`))
                            })
                        ]
                    }, `group-${group.slug}`))
            ]
        });
    }
}
